import { Component } from "react";
import { post } from "../lib/axios";
import { SERVER_URL } from "../config";

const FreshchatInitState = {
	IDLE: "IDLE",
	LOADING: "LOADING",
	ERRORED: "ERRORED",
	INITIALISED: "INITIALISED",
};

var freshchatServiceState = FreshchatInitState.IDLE;

const FallBackErrorMessage = "Something went Wrong!";

class FreshchatService extends Component {
	static async getUserHash(user: any) {
		const url = SERVER_URL + "/v1/support/freshworks/hash";
		const { data, error } = await post({ url, data: user });
		if (data) {
			return data.userHash;
		}
		if (error) {
			throw new Error(error);
		}
	}

	static async initialize(user: any) {
		if (freshchatServiceState === FreshchatInitState.INITIALISED) {
			return { success: true };
		}

		if (freshchatServiceState === FreshchatInitState.LOADING) {
			return { error: "Freshchat is already initialising" };
		}

		freshchatServiceState = FreshchatInitState.LOADING;

		try {
			if (typeof window.fcWidget === "undefined") {
				console.log("fcWidget is not loaded", window.fcWidget);
				freshchatServiceState = FreshchatInitState.ERRORED;
				return { error: "Freshchat widget is not loaded" };
			}

			if (!user) {
				freshchatServiceState = FreshchatInitState.ERRORED;
				console.log("Could not find valid user", user);
				return { error: "Could not find valid userUuid" };
			}

			window.fcWidget.init({
				externalId: user.uid,
			});

			const data = {
				externalId: user.uid,
				phone: user.phoneNumber,
			};

			window.fcWidget.user.setProperties(data).then(
				function () {
                    console.log("User Set");
                },
				function () {
					console.log("User Not Set");
				}
			);
		} catch (error: any) {
			console.log("Could not initialize Freshchat due to - ", error);
			freshchatServiceState = FreshchatInitState.ERRORED;
			return { error };
		}

		freshchatServiceState = FreshchatInitState.INITIALISED;
        console.log("Freshchat initialized");
		return { success: true };
	}

	static openFreshchatHelpDesk(): Promise<{ success?: boolean; error?: string }> {
		return new Promise((resolve) => {
			if (freshchatServiceState === FreshchatInitState.LOADING) {
				return resolve({ error: "Freshchat is still initialising" });
			}

			if (freshchatServiceState !== FreshchatInitState.INITIALISED) {
				console.log(freshchatServiceState);
				return resolve({ error: "Freshchat has not been initialized" });
			}

			try {
				if (typeof window.fcWidget === "undefined") {
					return resolve({ error: "Freshchat widget is not loaded" });
				}

				// Listen for the widget opened event
				window.fcWidget.on("widget:opened", function () {
					resolve({ success: true });
				});

				window.fcWidget.open();
			} catch (error: any) {
				resolve({ error: error?.message || FallBackErrorMessage });
			}
		});
	}
}

export default FreshchatService;
